export default __webpack_public_path__ + "static/media/comment.5b586580.svg";